import { useAuth } from './useAuth'

export function useAuthenticatedUserId(): string | undefined {
  const { userId } = useAuth()

  return userId
}
